import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Link } from 'react-router-dom'
import L from '../L'
import headerBg from '../../Images/ideacloud_header.png'
import header2Styles from './Header2-styles'

const logoImg = require('../../Images/IconFDXLogoSimple.png')

const Header = ({ classes, logo, title }) => {
  return (
    <div className={classes.l_header} style={{ backgroundImage: `url(${headerBg})` }}>
      <L container>
        <div className={classes.l_headerContent}>
          <Link to="/" className={classes.l_logo}>
            <div className={classes.icon}>
              <img src={logo} alt="Company Logo" />
            </div>
            <Typography className={classes.title} color="inherit" variant="h1">
              {title}
            </Typography>
          </Link>
        </div>
      </L>
    </div>
  )
}

Header.propTypes = {
  logo: PropTypes.string,
}
Header.defaultProps = {
  logo: logoImg,
}

export default withStyles(header2Styles)(Header)
